import React from "react";
import BaseColumn from "../../sisu/layout/BaseColumn.sisu";

const NeoColumn = (props) => {
  return (<BaseColumn custom="p-col" {...props}>{props.children}</BaseColumn>);
};

export default NeoColumn;